import React, { Fragment, isValidElement, Children } from 'react';
import { Switch } from 'react-router-dom';
const isFragment = (child) => child.type === Fragment;
const flatten = (target, children) => {
    Children.map(children, (child) => {
        if (isValidElement(child)) {
            if (isFragment(child)) {
                flatten(target, child.props.children);
            }
            else {
                target.push(child);
            }
        }
    });
};
const FragmentSupportingSwitch = ({ children }) => {
    const flattenedChildren = [];
    flatten(flattenedChildren, children);
    return React.createElement(Switch, null, flattenedChildren);
};
export default FragmentSupportingSwitch;
